module.exports = __webpack_public_path__ + "img/huafei.8c11f474.png";